import React from 'react';
import { useTranslation } from 'react-i18next';
import { format, isBefore, startOfYear, subYears } from 'date-fns';
import { fi } from 'date-fns/locale';
import styles from '../styles/LandingPageLifts.module.scss';

import { ConsumptionApp, OmaLummeApp } from '../../../omaLummeContext';

import Liftup from '../../Common/Liftup';
import Loading from '../../Common/Loading';

// Types.

// Utils.
import { roundNumber, setPriceFormat } from '../../../utils/billing';
import { capitalizeFirstLetter, generateDataPoints } from '../../../utils/consumption';
import { total } from '../../Graphs/ReportingGraph/ReportingGraph';

const ConsumptionLift: React.FunctionComponent = () => {
  const dispatch = ConsumptionApp.useDispatch();
  const { t } = useTranslation();
  const { basicData, loadingBasicData, selectedMeteringPoint, selectedMeteringPointContract, landingPage } = OmaLummeApp.useState();
  const { consumption, eliqForecast, consumptionEstimate } = ConsumptionApp.useState();

  const meteringpointContracts = basicData?.filter((mp) => mp.GSRN === selectedMeteringPoint?.meteringPointId);

  const basicContract = meteringpointContracts && meteringpointContracts[0];

  const meteringPointType = basicContract && basicContract.meteringpointType ? (basicContract.meteringpointType.toLowerCase() ?? '') : '';

  React.useEffect(() => {
    const newData = generateDataPoints(consumption?.items ?? [], 'month', t, 'private', false, meteringPointType, eliqForecast);

    if (total(newData, 'consumptionEstimate') > 0) {
      dispatch(['changeConsumptionEstimate', total(newData, 'consumption') + total(newData, 'consumptionEstimate')]);
    } else if (consumptionEstimate > 0 && total(newData, 'consumptionEstimate') === 0) {
      dispatch(['changeConsumptionEstimate', 0]);
    }
  }, [consumption, meteringPointType, eliqForecast]);

  const change =
    consumptionEstimate && landingPage.lastYearConsumption ? (consumptionEstimate / landingPage.lastYearConsumption) * 100 - 100 : undefined;

  const meteringPointContracts = basicData?.filter((mp) => mp.GSRN !== null && mp.GSRN === selectedMeteringPoint?.meteringPointId);

  const selectedMeteringPointEndDate = basicData?.find(
    (d) => d.GSRN === selectedMeteringPoint?.meteringPointId && d.contractNo === selectedMeteringPoint.contractNo.toString(),
  )?.contractEndDate;

  return (
    <>
      {landingPage.currentMonthConsumption === undefined &&
        !loadingBasicData &&
        selectedMeteringPoint &&
        meteringPointContracts &&
        selectedMeteringPointContract?.contractType.contractTypeName.toLowerCase() === 'power' &&
        !(selectedMeteringPointEndDate && isBefore(new Date(selectedMeteringPointEndDate), startOfYear(subYears(new Date(), 1)))) && (
          <Liftup>
            <Loading size="small" />
          </Liftup>
        )}
      {landingPage.currentMonthConsumption !== undefined && (
        <Liftup link="/consumption" className="smallPaddingRight">
          <h4>{t('consumption:consumption.electricityConsumption')}</h4>
          <div className={styles.consumptionGrid}>
            <div>
              <span className={styles.sans}>{capitalizeFirstLetter(format(new Date(), 'LLLL -yy', { locale: fi }))}</span>
              <h3 className="h2">
                {setPriceFormat(roundNumber(landingPage.currentMonthConsumption, false, 0))} <span>kWh</span>
              </h3>
            </div>
            {landingPage.lastYearConsumption !== undefined && (
              <div>
                <span className={styles.sans}>{capitalizeFirstLetter(format(subYears(new Date(), 1), 'LLLL -yy', { locale: fi }))}</span>
                <h3 className={`h2 ${styles.grey}`}>
                  {setPriceFormat(roundNumber(landingPage.lastYearConsumption, false, 0))} <span>kWh</span>
                </h3>
              </div>
            )}
            {consumptionEstimate !== undefined && (
              <div>
                <span className={styles.sans}>{t(`consumption:consumption.reportingGraph-forecast`)}</span>
                <h3 className={`h2 ${styles.grey}`}>
                  {setPriceFormat(roundNumber(consumptionEstimate, false, 0))} <span>kWh</span>
                </h3>
              </div>
            )}
            {change !== undefined && (
              <div>
                <span className={styles.sans}>{t(`consumption:consumption.csv-comparisonChange`)}</span>
                <h3 className={`h2 ${change < 0 ? styles.negative : styles.positive}`}>
                  {`${change > 0 ? '+' : ''}`}
                  {roundNumber(change, false, 0)} <span>%</span>
                </h3>
              </div>
            )}
          </div>
        </Liftup>
      )}
    </>
  );
};

export default ConsumptionLift;
